import { render, staticRenderFns } from "./CheckboxItem.vue?vue&type=template&id=1f08ec5d&scoped=true&"
import script from "./CheckboxItem.vue?vue&type=script&lang=js&"
export * from "./CheckboxItem.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxItem.vue?vue&type=style&index=0&id=1f08ec5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f08ec5d",
  null
  
)

export default component.exports